import { useMutation } from '@tanstack/react-query';
import { SetSellLimitParameters, useRepositoryRegistry } from '@mews-commander/data-access';

export const useSetSellLimit = () => {
    const { sellLimits } = useRepositoryRegistry();

    return useMutation({
        mutationFn: async (params: SetSellLimitParameters) => sellLimits.set(params),
    });
};
